var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-b6f408c5-c090-4ab4-921a-ff24f1012f1d",
    "data-name": "uuid-95408ed6-2623-425d-94f3-a4361a3ddcb8",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 921.79 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-11aeed02-1568-4634-9903-afbf4bdf1fb1",
    d: "M878.94,199.29h-185.54v-81.43c0-64.99-52.87-117.86-117.86-117.86h-229.29c-64.99,0-117.86,52.87-117.86,117.86v81.43H42.86c-23.67,0-42.86,19.19-42.86,42.86s19.19,42.86,42.86,42.86h47.52l40.53,721.45c.77,40.69,34.11,73.55,74.99,73.55h510c40.87,0,74.21-32.86,74.99-73.55l40.53-721.45h47.52c23.67,0,42.86-19.19,42.86-42.86s-19.19-42.86-42.86-42.86ZM314.11,117.86c0-17.75,14.39-32.14,32.14-32.14h229.29c17.75,0,32.14,14.39,32.14,32.14v79.29h-293.57v-79.29ZM705.72,994.29H216.08l-39.85-709.29h569.33l-39.85,709.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-11aeed02-1568-4634-9903-afbf4bdf1fb1",
    d: "M356.97,824.45c23.67,0,42.86-19.19,42.86-42.86v-350.88c0-23.67-19.19-42.86-42.86-42.86s-42.86,19.19-42.86,42.86v350.88c0,23.67,19.19,42.86,42.86,42.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-11aeed02-1568-4634-9903-afbf4bdf1fb1",
    d: "M564.82,824.45c23.67,0,42.86-19.19,42.86-42.86v-350.88c0-23.67-19.19-42.86-42.86-42.86s-42.86,19.19-42.86,42.86v350.88c0,23.67,19.19,42.86,42.86,42.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.3cbba9c514e21d76319f4573c7d29bcb.svg";
export { ForwardRef as ReactComponent };